import React from 'react';
import { createStringParser, normalizers } from '../stringParser';
import type { ParsedSegment } from '../stringParser';
import type {
  TextEffectsSharedData,
  TextEffectsSharedMapperProps,
} from '../../TextEffectsShared.types';

interface Params {
  text: string;
  language: string;
  textDirection: TextEffectsSharedMapperProps['textDirection'];
  patternScope?: TextEffectsSharedData['patternScope'];
}

interface Result {
  content: Array<Array<ParsedSegment>>;
  arePatternsDisabled: boolean;
}

export const usePatterns = (params: Params): Result => {
  const { text, language, patternScope, textDirection } = params;

  const scope = patternScope ?? 'none';
  const arePatternsDisabled = scope === 'none';

  const stringParser = React.useMemo(() => {
    if (arePatternsDisabled) {
      return;
    }
    const _stringParser = createStringParser({
      locale: language,
      granularity: scope,
      normalizers,
    });
    return _stringParser;
  }, [arePatternsDisabled, language, scope]);

  const content = React.useMemo(() => {
    if (arePatternsDisabled || !stringParser) {
      return;
    }
    return stringParser.parse(text, { textDirection }).segmentsBrokenByLines;
  }, [arePatternsDisabled, text, stringParser, textDirection]);

  return {
    content: content ?? [[{ data: text, isVisible: true }]],
    arePatternsDisabled,
  };
};
